import styled from 'styled-components';

import { StyledFilterDrawer } from '@components/views/components/listing/drawer/ResponsiveListingFilterAndSortStyle';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.grey1100};
  color: ${({ theme }) => theme.palette.white};
`;
export const ContentWrapper = styled.div`
  padding: 14px 16px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 20px 120px;
  }
`;

export const DrawerWrapper = styled.div`
  padding: 24px 12px 50px 12px;
`;

export const UserMenuWrapper = styled.div`
  color: white;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;
  padding: 6px 6px 6px 12px;
`;

export const Rectangle = styled.div`
  width: 1px;
  height: 24px;
  background: rgba(255, 255, 255, 0.3);
  margin: 0 16px 0px 16px;
  color: ${({ theme }) => theme.palette.white};
`;
export const WrapperReservation = styled.div`
  color: ${({ theme }) => theme.palette.white};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  word-wrap: break-word;
  margin-top: 3px;
  display: flex;
  align-items: center;
  padding: 8px 15px;
`;

export const BottomHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    > a > span > img {
      min-height: 60% !important;
      min-width: 60% !important;
      margin-left: 0px !important;
      margin-right: 5px !important;
    }
    > a {
      margin-left: 0px !important;
      margin-right: 5px !important;
      max-width: 150px !important;
    }
  }
`;

export const MenuContent = styled.div`
  display: flex;

  align-items: center;
  position: relative;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    flex-direction: row;
    justify-content: flex-end;
    left: 0px;
    text-align: center;
  }
`;
export const DetailContent = styled.div`
  display: flex;
  display: inline-flex;
  align-items: center;
  position: relative;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    justify-content: flex-end;
    left: 0px;
  }
`;

export const ArrivalDetail = styled.div`
  color: ${({ theme }) => theme.palette.grey600};
  font-size: 10px;
  font-weight: 500;
  line-height: 16px;
`;
export const UserContainer = styled.div`
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 20px 120px;
  }
`;
export const CircleText = styled.div`
  padding: 6px;
  color: white;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  word-wrap: break-word;
`;

export const IconWrapper = styled.div`
  position: relative;
  padding: 8px 8px 8px 8px;
  overflow: hidden;
`;

export const EllipseWrapper = styled.div`
  width: 36px;
  height: 36px;
  background: ${({ theme }) => theme.palette.yellow500};
  border-radius: 9999px;
`;
export const HeaderLink = styled.a`
  color: ${({ theme }) => theme.palette.white};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  word-wrap: break-word;
  margin-top: 3px;
  display: flex;
  align-items: center;
  padding: 8px 15px;

  &:hover {
    color: ${({ theme }) => theme.palette.white};
  }
`;

export const Circle = styled.div`
  position: absolute;
  right: 0;
  top: 2px;
  width: 8px;
  height: 8px;
  background: ${({ theme }) => theme.palette.red600};
  border-radius: 50%;
`;

export const CircleWrapper = styled.div`
  position: relative;
`;

export const StyledBurger = styled.button<{ isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ isOpen }) =>
    isOpen ? 'space-around' : 'space-evenly'};
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  width: 2rem;
  height: 2rem;

  justify-content: center;
  align-items: center;
  gap: 6px;
  display: inline-flex;
  &:focus {
    outline: none;
  }
`;

export const Drawer = styled(StyledFilterDrawer)`
  .setur-drawer-content-wrapper {
    height: 100% !important;
  }

  .setur-drawer-header {
    height: 60px;
    padding: 18px 16px;
    background: ${({ theme }) => theme.palette.grey1100};

    .setur-drawer-header-title {
      flex-direction: row-reverse;

      .setur-drawer-title {
        color: ${({ theme }) => theme.palette.white};
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
        margin: 0px;
        text-align: left;
      }
    }
  }

  .setur-drawer-body {
    margin-bottom: 0px;
    overflow: auto;
    padding: 24px 12px 50px 12px !important;
  }

  .setur-drawer-footer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-top: 1px solid ${({ theme }) => theme.palette.grey300};
    background: ${({ theme }) => theme.palette.white};
    padding: 12px;
  }
`;
